import Model, { ID, IsoDateTime, MODEL_LEVEL } from 'src/models/Model'

export default class InventoryItemUnit extends Model {
  static name = 'InventoryItemUnit'

  static versioned = true

  static deletable = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Inventory]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      description: {
        type: String
      },
      baseQuantity: {
        type: Number,
        default: 1
      },
      hasAdjustments: {
        type: Boolean,
        output: true,
        default: false
      },
      action: {
        type: String,
        input: true
      },
      archivedAt: {
        type: IsoDateTime,
        output: true
      },
      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      },
      receiveLibraryUpdates: {
        type: Boolean,
        output: true,
        excludeFromDefault: true
      }
    }

    this.computed = {
      active () {
        return !this.archivedAt
      },
      deletable () {
        return !this.isDirty && this.baseQuantity > 1 && !this.hasAdjustments
      },
      archivable () {
        return this.isRemote && !this.isDirty && this.baseQuantity > 1
      },
      baseQuantityIsImmutable () {
        return this.isRemote && (
          (this.baseQuantity === 1 && !_.includes(_.keys(this.describeDirty), 'baseQuantity')) ||
          this.hasAdjustments
        )
      }
    }
  }
}
